<template>
  <pt-customer-of-system class="pt-customer-of-system__page"></pt-customer-of-system>
</template>

<script>
import PtCustomerOfSystem from 'cps/customer-manage/pt-customer-of-system/withData'
export default {
  name: 'pt-customer-of-system__view',
  components: {
    'pt-customer-of-system': PtCustomerOfSystem
  }
}
</script>
